if (!customElements.get("orsay-story")) {
  class OrsayStory extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector("video");
      this.progressBar = this.querySelector(".orsay-story__progress-bar-line");
      this.controls = {
        closeButton: this.querySelector(".orsay-story__close-button"),
        pauseButton: this.querySelector(".orsay-story__controls-button--pause"),
        playButton: this.querySelector(".orsay-story__controls-button--play"),
        muteButton: this.querySelector(".orsay-story__controls-button--mute"),
        unmuteButton: this.querySelector(
          ".orsay-story__controls-button--unmute"
        ),
      };

      this.animationFrameId = null;
      this.isPlaying = false;
    }

    connectedCallback() {
      this.#initializeControls();
      this.#setupVideoEvents();
    }

    disconnectedCallback() {
      this.#cleanup();
    }

    #initializeControls() {
      if (this.controls.pauseButton && this.controls.playButton) {
        this.controls.pauseButton.addEventListener("click", () => this.pause());
        this.controls.playButton.addEventListener("click", () => this.play());
      }

      if (this.controls.muteButton && this.controls.unmuteButton) {
        this.controls.muteButton.addEventListener("click", () => this.mute());
        this.controls.unmuteButton.addEventListener("click", () =>
          this.unmute()
        );
      }
    }

    #setupVideoEvents() {
      if (!this.video) return;

      this.video.addEventListener("play", () => {
        this.isPlaying = true;
        this.#updateProgress();
        this.showControl(this.controls.pauseButton, this.controls.playButton);
      });

      this.video.addEventListener("pause", () => {
        this.isPlaying = false;
        this.#cancelProgressUpdate();
        this.showControl(this.controls.playButton, this.controls.pauseButton);
      });

      this.video.addEventListener("ended", () => {
        this.isPlaying = false;
        this.#cancelProgressUpdate();
        this.dispatchEvent(new CustomEvent("story-ended"));
      });
    }

    #updateProgress() {
      if (!this.video || !this.progressBar) return;

      const updateFrame = () => {
        if (!this.isPlaying) return;

        const progress = this.video.currentTime / this.video.duration;
        this.progressBar.style.transform = `scaleX(${progress})`;
        this.animationFrameId = requestAnimationFrame(updateFrame);
      };

      this.animationFrameId = requestAnimationFrame(updateFrame);
    }

    #cancelProgressUpdate() {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    }

    play() {
      if (!this.video) return;
      this.video.play();
      this.showControl(this.controls.pauseButton, this.controls.playButton);
    }

    pause() {
      if (!this.video) return;
      this.video.pause();
      this.showControl(this.controls.playButton, this.controls.pauseButton);
    }

    mute() {
      if (!this.video) return;
      this.video.muted = true;
      this.showControl(this.controls.unmuteButton, this.controls.muteButton);
    }

    unmute() {
      if (!this.video) return;
      this.video.muted = false;
      this.showControl(this.controls.muteButton, this.controls.unmuteButton);
    }

    showControl(activeButton, inactiveButton) {
      if (!activeButton || !inactiveButton) return;

      inactiveButton.classList.remove("orsay-story__controls-button--active");
      activeButton.classList.add("orsay-story__controls-button--active");
    }

    reset() {
      if (!this.video) return;
      this.video.pause();
      this.video.currentTime = 0;
      if (this.progressBar) {
        this.progressBar.style.transform = "scaleX(0)";
      }
    }

    #cleanup() {
      this.#cancelProgressUpdate();
    }
  }

  customElements.define("orsay-story", OrsayStory);
}
